(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["salonlove-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sl-home-carousel')) {
  customElements.define('sl-home-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.current = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-goto]'));
      this.toggle = this.querySelector('[data-toggle]');
      this.querySelector('.sl-carousel__controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.current - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.current + 1));
      this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.goto))));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.syncToggle(); });
      this.addEventListener('pointerenter', () => this.hovered = true);
      this.addEventListener('pointerleave', () => this.hovered = false);
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      this.querySelector('.sl-carousel__track').addEventListener('touchstart', event => {
        this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      this.querySelector('.sl-carousel__track').addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.show(this.current + (dx < 0 ? 1 : -1));
        this.touchStart = null;
      }, { passive: true });
      this.syncToggle();
      this.restart();
    }
    syncToggle() {
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    restart() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !this.contains(document.activeElement) && !document.hidden && this.getBoundingClientRect().bottom > 0) this.show(this.current + 1);
      }, 8000);
    }
    show(next) {
      this.current = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.inert = i !== this.current; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
      this.restart();
    }
    disconnectedCallback() { clearInterval(this.timer); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
